import { useLocation, useHistory } from "react-router-dom";
import "./product.css";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateProduct } from "../../redux/apiCalls";
import Select from "react-select";
import { publicRequest } from "../../requestMethods";

export default function Product() {
    const location = useLocation();
    const history = useHistory();
    const productId = location.pathname.split("/")[2];
    const [inputs, setInputs] = useState({});
    const dispatch = useDispatch();
    const [categories, setCategories] = useState([]);
    const [principles, setPrinciples] = useState([]);

    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin === true : null
    );

    const product = useSelector((state) =>
        state.product.products.find((product) => product._id === productId)
    );

    // Redirect if not superadmin
    useEffect(() => {
        if (superadmin === false) {
            history.push("/");
        }
    }, [superadmin, history]);

    const getAllCategories = async () => {
        const res = await publicRequest.get("/category/all", {
            params: { isAdmin: true },
        });
        setCategories(res.data);
    };

    const getAllPrinciples = async () => {
        try {
            const params = {
                type: ["outright"],
            };

            const res = await publicRequest.get("/users/admin", {
                params,
            });
            setPrinciples(res.data);
        } catch (err) {
            console.error("Error fetching principles:", err);
        }
    };

    useEffect(() => {
        if (categories.length === 0) {
            getAllCategories();
        }
        if (principles.length === 0) {
            getAllPrinciples();
        }
    }, [categories, principles]);
    

    const handleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleCategoryChange = (e) => {
        setInputs((prev) => {
            return { ...prev, category: e.value };
        });
    };

    const handlePrincipleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, principle: e ? e.value : null };
        });
    };

    // Resolve category for Select: use inputs if user changed it, else product's category (may be object or id string)
    const categoryId = inputs.category !== undefined
        ? inputs.category
        : (product?.category?._id ?? (typeof product?.category === "string" ? product.category : undefined));
    const categorySelectValue = categoryId != null
        ? (() => {
            const c = categories.find((cat) => cat._id === categoryId);
            return c ? { label: c.title, value: c._id } : { label: product?.category?.title, value: categoryId };
        })()
        : null;

    // Resolve principle for Select: use inputs if user changed it, else product's principle
    const principleId = inputs.principle !== undefined ? inputs.principle : product?.principle?._id;
    const principleSelectValue = principleId != null
        ? (() => {
            const p = principles.find((pr) => pr._id === principleId);
            return p ? { label: p.name || p.email, value: p._id } : { label: product?.principle?.name || product?.principle?.email, value: principleId };
        })()
        : null;

    const handleClick = async () => {
        const updatedProduct = {
            ...product,
            title: inputs.title !== undefined ? inputs.title : product.title,
            category: inputs.category !== undefined ? inputs.category : product.category,
            itemCode: inputs.itemCode !== undefined ? inputs.itemCode : product.itemCode,
            principle: inputs.principle !== undefined ? inputs.principle : product.principle,
            minimumPrice: inputs.minimumPrice !== undefined ? inputs.minimumPrice : product.minimumPrice,
        };
        await updateProduct(product._id, updatedProduct, dispatch);
    };

    if (!superadmin) {
        return null;
    }

    return (
        <div className="product">
            <h1 className="addProductTitle">Update Product</h1>
            <div className="addProductForm">
                <div className="addProductItem">
                    <label>Product Title</label>
                    <input
                        name="title"
                        type="text"
                        placeholder={product?.title}
                        defaultValue={product?.title}
                        onChange={handleChange}
                    />
                </div>
                <div className="addProductItem">
                    <label>Category</label>
                    <Select
                        options={categories.map((category) => ({
                            label: category.title,
                            value: category._id,
                        }))}
                        value={categorySelectValue}
                        onChange={handleCategoryChange}
                        placeholder="Select Category"
                    />
                </div>
                <div className="addProductItem">
                    <label>Item Code</label>
                    <input
                        name="itemCode"
                        type="text"
                        placeholder={product?.itemCode || "Item Code"}
                        defaultValue={product?.itemCode}
                        onChange={handleChange}
                    />
                </div>
                <div className="addProductItem">
                    <label>Principle</label>
                    <Select
                        options={principles.map((user) => ({
                            label: user.name || user.email,
                            value: user._id,
                        }))}
                        value={principleSelectValue}
                        onChange={handlePrincipleChange}
                        placeholder="Select Principle (Optional)"
                        isClearable
                    />
                </div>
                <div className="addProductItem">
                    <label>Minimum Price</label>
                    <input
                        name="minimumPrice"
                        type="number"
                        placeholder={product?.minimumPrice || "Minimum Price"}
                        defaultValue={product?.minimumPrice}
                        onChange={handleChange}
                    />
                </div>
                <div
                    onClick={() => handleClick()}
                    className="updateProductButton"
                >
                    Update Product
                </div>
            </div>
        </div>
    );
}
